import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';
import { UserInformation } from '@model';

@Injectable()
export class UserInformationService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getUserInformations(): Observable<UserInformation[]> {
    return this.http
      .get<UserInformation[]>(`${environment.apiEndpoint}/information/userInformation`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  setInformationAsRead(informationId: Number): Observable<UserInformation> {
    return this.http
      .get<UserInformation>(`${environment.apiEndpoint}/information/userInformation/SetRead/${informationId}`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
